import React from "react";

import Divider from "antd/es/divider";
import cn from "classnames";

import styles from "./TextWithLine.module.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
}

const TextWithLine: React.FC<Props> = ({ children, className }) => (
  <div>
    <div className={cn(styles.text, className)}>{children}</div>
    <Divider className={styles.divider} orientation="left" />
  </div>
);

export default TextWithLine;
